import { RangerSearchComponentBase } from './ranger-search.component.base';
import { Component, Injector, Input, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { Action, CrudDataSource, FilteredArrayDataSource, FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { BusinessUnitEmailContactService, BusinessUnitService, CostCentreService, RangerService, RangerSourceMapService, RefCodeStorage } from 'assets-service';
import { BusinessUnit, RangerSourceMap, RANGER_STATUS_ACTIVE, COST_CENTRE_TYPE_WILDLIFE, Ranger } from 'assets-model';
import { Observable, of } from 'rxjs';
import moment from 'moment';
import { MatSelect } from '@angular/material/select';


@Component({
  selector: 'app-ranger-search',
  templateUrl: './ranger-search.component.html',
  styleUrls: ['./ranger-search.component.scss']
})
export class RangerSearchComponent extends RangerSearchComponentBase {

  displayedColumns: string[] = ['rangerId', 'businessUnit.buId', 'costCentre.ccId', 'name', 'email', 'rangerSource.rangerSourceMapId', 'town', 'postcode','mobilePhone', 'status', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'provisionalRanger', 'volunteerRanger','wildlifeManagerRanger' ,'firearmsAuthorityExpiryDate', 'actions'];

  disabledColumns: string[] = ['rangerId', 'rangerSource.rangerSourceMapId', 'createdBy', 'addr1', 'addr2', 'addr3', 'createdDate', 'updatedBy', 'updatedDate',  'provisionalRanger', 'volunteerRanger', 'firearmsAuthorityIssueDate', ]

  readyForSearch: boolean = false;

  firearmsAuthorityExpiredFilter: boolean;
  @ViewChild('firearmsAuthorityExpiredFilterInput') firearmsAuthorityExpiredFilterInput: MatSelect;

  firearmsAuthorityExpiringSoonFilter: boolean;
  @ViewChild('firearmsAuthorityExpiringSoonFilterInput') firearmsAuthorityExpiringSoonFilterInput: MatSelect;

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected rangerService: RangerService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected policeContactService: BusinessUnitEmailContactService,
    protected rangerSourceService: RangerSourceMapService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, rangerService, businessUnitService, costCentreService, policeContactService, rangerSourceService, refCodeStorage, fb, formStorage, injector);
    this.searchForm.addControl('firearmsAuthorityExpired', new FormControl());
    this.searchForm.addControl('firearmsAuthorityExpiringSoon', new FormControl());
  }

  ngAfterViewInit(): void {
    super.ngAfterViewInit();
    this.addSearchOnChangedSelectEventListener(this.firearmsAuthorityExpiredFilterInput);
    this.addSearchOnChangedSelectEventListener(this.firearmsAuthorityExpiringSoonFilterInput);
  }

  createServiceArguments(): any {
    var filters = super.createServiceArguments();
    if (filters.mobilePhone != null) {
      filters.mobilePhone = filters.mobilePhone.replaceAll('+', '');
    }
    filters.firearmsAuthorityExpired = this.firearmsAuthorityExpiredFilter;
    filters.firearmsAuthorityExpiringSoon = this.firearmsAuthorityExpiringSoonFilter;
    return filters;
  }

  protected onInitAsyncComplete() {
    this.businessUnitLoadSelectionList();
    this.costCentreLoadSelectionList();
    this.statusLoadSelectionList();
    this.policeContactLoadSelectionList();

    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
    this.readyForSearch = true;
    super.onInitAsyncComplete();
  }

  resetSearchForm() {

  }

  clearFilterVariables(): void {
    super.clearFilterVariables();
    this.firearmsAuthorityExpiredFilter = null;
    this.firearmsAuthorityExpiringSoonFilter = null;
  }

  isReadyForSearch(): boolean {
    return this.readyForSearch;
  }

  exportFirearmsByPoliceAuthorityReport(): void {
    this.rangerService.exportFirearmsByPoliceAuthorityReport(this.createServiceArguments(), 'XLS', true);
  }

  policeContactLoadSelectionList() {
    var filters = {
      buId: this.businessUnitFilter?.buId,
    }
    this.policeContactService.findByFullFilters(filters, null).subscribe(
      data => {
        this.policeContactSelectionList = data.items;
      }
    );
  }

  businessUnitLoadSelectionList() {
    this.businessUnitService.findAll(true).subscribe(
      data => {
        this.businessUnitSelectionList = data.items;
      }
    );
  }

  costCentreLoadSelectionList() {
    if (this.businessUnitFilter != null) {
      this.costCentreService.findByBusinessUnitForType(this.businessUnitFilter?.buId, COST_CENTRE_TYPE_WILDLIFE).subscribe(
        data => {
          this.costCentreSelectionList = data.items;
          var costCentreStillContained = false;
          for (let cc of this.costCentreSelectionList) {
            if (this.costCentreCompare(cc, this.costCentreFilter)) {
              costCentreStillContained = true;
              break;
            }
          }
          if (!costCentreStillContained) {
            this.costCentreFilter = null;
          }
          this.costCentre.enable();
        }
      );
    } else {
      this.costCentreSelectionList = [];
      this.costCentreFilter = null;
      this.costCentre.disable();
    }
  }

  firearmsAuthorityExpiredChanging(value: boolean, unsetDependents: boolean = true) {}
  
  firearmsAuthorityExpiredChanged(value: boolean, unsetDependents: boolean = true) {}

  firearmsAuthorityExpiringSoonChanging(value: boolean, unsetDependents: boolean = true) {}

  firearmsAuthorityExpiringSoonChanged(value: boolean, unsetDependents: boolean = true) {}

  rangerSourceSelectionListFilterLoad(text: string): Observable<RangerSourceMap[]> {
    return of([]);
  }

  businessUnitChanged(value: BusinessUnit, unsetDependents: boolean = true) {
    super.businessUnitChanged(value, unsetDependents);
    this.costCentreLoadSelectionList();
    this.policeContactLoadSelectionList();
  }

  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    const self = this;
    var setters = this.transformAllPropertiesToModelSetters();
    setters['firearmsAuthorityExpired'] = (value: any) => self.firearmsAuthorityExpiredFilter = value == null ? null : (value == 'true');
    setters['firearmsAuthorityExpiringSoon'] = (value: any) => self.firearmsAuthorityExpiringSoonFilter = value == null ? null : (value == 'true');
    return setters;
  }


  get firearmsAuthorityExpired() {
    return this.searchForm && this.searchForm.get('firearmsAuthorityExpired');
  }

  get firearmsAuthorityExpiringSoon() {
    return this.searchForm && this.searchForm.get('firearmsAuthorityExpiringSoon');
  }

  isFirearmsExpired(value: any): boolean {
    if (value == null) { 
      return false; 
    }
    const expiryMoment = moment(value);
    if (!expiryMoment.isValid()) { 
      return false; 
    }
    return expiryMoment.isBefore(moment(), 'day');
  }
}

@Component({
  selector: 'app-ranger-list',
  templateUrl: './ranger-list.component.html',
  styleUrls: ['./ranger-search.component.scss']
})
export class RangerListComponent extends RangerSearchComponentBase {

  displayedColumns: string[] = ['rangerId', 'status', 'businessUnit.buId', 'costCentre.ccId', 'name', 'email', 'rangerSource.rangerSourceMapId', 'addr1', 'addr2', 'addr3', 'town', 'postcode', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate','provisionalRanger', 'volunteerRanger', 'wildlifeManagerRanger', 'actions'];

  disabledColumns: string[] = ['rangerId', 'rangerSource.rangerSourceMapId', 'addr1', 'addr2', 'addr3', 'town', 'postcode', 'createdBy', 'createdDate', 'updatedBy', 'updatedDate', 'provisionalRanger', 'volunteerRanger', 'wildlifeManagerRanger'];

  private listDataSource: RangerListDataSource = new RangerListDataSource();

  @Input()
  set items(v: Ranger[]) {
    this.listDataSource.items = v;
  }
  get items(): Ranger[] {
    return this.listDataSource.items;
  }

  _actions: Action[] = [];
  @Input()
  set actions(v: Action[]) {
    this._actions = v;
  }
  get actions(): Action[] {
    return this._actions;
  }

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected rangerService: RangerService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected policeContactService: BusinessUnitEmailContactService,
    protected rangerSourceService: RangerSourceMapService,
    protected refCodeStorage: RefCodeStorage,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, rangerService, businessUnitService, costCentreService, policeContactService,
       rangerSourceService, refCodeStorage, fb, formStorage, injector);
  }

  createDataSource(): CrudDataSource<Ranger> {
    return this.listDataSource;
  }

  rangerSourceSelectionListFilterLoad(text: string): Observable<RangerSourceMap[]> {
    return of([]);
  }

  reload() {
    this.listDataSource.reload();
  }
}

class RangerListDataSource extends FilteredArrayDataSource<Ranger> {
  private _items: Ranger[] = [];


  set items(v: Ranger[]) {
    this._items = v;
    this.reload();
  }
  get items(): Ranger[] {
    return this._items;
  }
  protected getDelegate(): Ranger[] {
    return this._items;
  }
}



